/** @format */

import APIRequest from "../utils/APIRequest";
import APIRequestONX from "../utils/APIRequestONX";

export default class PhoneNumber {
  static getAll = async (waba_id) => {
    return await APIRequest.set(`v1/phone_numbers/${waba_id}`, "GET");
  };

  static getByID = async (id) => {
    return await APIRequest.set(`v1/phone_number/${id}`, "GET");
  };

  static getOnPrem = async (id) => {
    return await APIRequest.set(`v1/whatsappnumber/id/${id}`, "GET");
  };

  static getToken = async (body) => {
    return await APIRequest.set("v1/get-cloud-token", "POST", body);
  };

  static getDetailByIdWithWebhook = async (body) => {
    return await APIRequest.set(`v1/get_profile`, "POST", body);
  };

  static postImage = async (file) => {
    return await APIRequestONX.setMultipart("minio/upload", "POST", file);
  };

  static waGetByID = async (id) => {
    return await APIRequest.set(`v1/whatsappnumber/${id}`, "GET");
  };

  static register = async (body) => {
    return await APIRequest.set(`v1/whatsappnumber/`, "POST", body);
  };

  static updateNumber = async (id, body) => {
    return await APIRequest.set(`v1/whatsappnumber/id/${id}`, "PUT", body);
  };

  static getBusinessProfile = async (phone_number) => {
    return await APIRequest.set(
      `v1/whatsappnumber/business-profile/${phone_number}`,
      "GET"
    );
  };

  static updateBusinessProfile = async (body) => {
    return await APIRequest.set("v1/whatsappnumber/profile", "POST", body);
  };

  static getDockerHealth = async (id) => {
    return await APIRequest.set(`v1/whatsappnumber/docker/${id}`, "GET");
  };

  // ini
  // static updateBusinessProfile = async (body) => {
  //   // return await APIRequest.set("v1/update_profile", "POST", body);
  //   // return await APIRequest.set(
  //   //   `v1/whatsappnumber-op/profile/` + id,
  //   //   "PUT",
  //   //   body
  //   // );
  // };

  // ini
  static updateBusinessProfilePicture = async (body) => {
    return await APIRequest.set(`v1/update_picture`, "POST", body);
  };

  static testConnection = async (url, username, password) => {
    // console.log("PARAMS", url, username, password);
    return await APIRequest.set(`v1/whatsappnumbers/testLogin`, "POST", {
      url,
      username,
      password,
    });
  };

  static getWebhookSettingByPhoneNumber = async (phone_number) => {
    return await APIRequest.set(
      `v1/webhook_setting/byphonenumber/${phone_number}`,
      "GET"
    );
  };

  static postWebhookSetting = async (body) => {
    return await APIRequest.set(`v1/webhook_setting`, "POST", body);
  };
}
